import { defineComponent } from 'vue-demi';
import _ from 'lodash';
import { openBlock, createElementBlock, Fragment, renderList, createElementVNode, resolveComponent, createVNode, createBlock, renderSlot } from 'vue';
import { s as styleInject } from './style-inject.es-20d2f1f5.js';
import { DASHBOARD_SERVICE } from './constants/index.js';

var script$4 = defineComponent({
  name: 'BrandLogo',
  props: {
    logo: {
      type: [Array, String],
      required: true
    }
  },
  computed: {
    logos() {
      if (_.isString(this.logo)) {
        return [{
          src: this.logo,
          href: '/'
        }];
      }
      if (_.isArray(this.logo)) {
        return this.logo;
      }
      return null;
    }
  }
});

const _hoisted_1$4 = {
  class: "brand-logo",
  "data-test": "brand-logo"
};
const _hoisted_2$3 = ["href", "target"];
const _hoisted_3$3 = ["src"];
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$4, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.logos, (item, index) => {
    return openBlock(), createElementBlock("a", {
      key: index,
      href: item.href,
      target: item.href === '/' ? '_self' : '_blank'
    }, [createElementVNode("img", {
      src: item.src,
      class: "logo"
    }, null, 8 /* PROPS */, _hoisted_3$3)], 8 /* PROPS */, _hoisted_2$3);
  }), 128 /* KEYED_FRAGMENT */))]);
}

var css_248z$2 = ".brand-logo[data-v-2987a052] {\n  display: grid;\n  grid-auto-flow: column;\n  grid-gap: 8px;\n  align-items: end;\n  float: left;\n  max-width: 100%;\n  padding: 12px 0;\n  overflow: hidden;\n}\n.brand-logo img[data-v-2987a052] {\n  max-height: 24px;\n}";
styleInject(css_248z$2);

script$4.render = render$4;
script$4.__scopeId = "data-v-2987a052";
script$4.__file = "src/components/ServiceNavigationLogo/BrandLogo.vue";

var script$3 = defineComponent({
  name: 'DefaultBigLogo',
  props: {
    fill: {
      type: String,
      default: 'white'
    },
    height: {
      type: String,
      default: '16px'
    }
  }
});

const _hoisted_1$3 = ["height"];
const _hoisted_2$2 = {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
};
const _hoisted_3$2 = ["fill"];
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    height: _ctx.height,
    viewBox: "0 0 145 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [createElementVNode("g", _hoisted_2$2, [createElementVNode("path", {
    d: "M22.7040609,6.33801588 L24.8113161,6.33801588 L24.8113161,8.43207399 C25.4193798,7.2000698 26.8923617,6.10766949 29.0747513,6.10766949 C31.8162799,6.10766949 33.7453096,7.60317599 33.7453096,11.4562429 L33.7453096,19.5934037 L31.6380543,19.5934037 L31.6380543,11.3061687 C31.6380543,8.973039 30.6490772,7.93473519 28.5173596,7.93473519 C26.5621202,7.93473519 24.8113161,9.17720967 24.8113161,11.5592008 L24.8113161,19.5951488 L22.7040609,19.5951488 L22.7040609,6.33801588 Z M36.4431555,13.1053137 L36.4431555,12.9028881 C36.4431555,8.89974697 39.0064585,6.10766949 42.66183,6.10766949 C45.7336001,6.10766949 48.6271446,7.95742082 48.6271446,12.6987174 L48.6271446,13.3845214 L38.625545,13.3845214 C38.726889,16.3999651 40.1736612,18.0734665 42.8907275,18.0734665 C44.9455635,18.0734665 46.1389759,17.3126254 46.4185454,15.7665125 L48.5188114,15.7665125 C48.0610163,18.4294564 45.8524171,19.8220051 42.8575286,19.8220051 C39.1078024,19.8220051 36.4431555,17.1869819 36.4431555,13.1053137 Z M46.4692174,11.6918244 C46.2665295,8.94860832 44.8494615,7.85271791 42.66183,7.85271791 C40.4741985,7.85271791 39.0571305,9.32902888 38.7024266,11.6918244 L46.4692174,11.6918244 Z M51.7950167,1.47107582 L57.2553589,1.47107582 C60.7325048,1.47107582 63.5998397,2.88980019 63.5998397,6.51426577 L63.5998397,6.61547858 C63.5998397,9.60649158 61.5956757,11.0775674 59.107507,11.5592008 L64.6656985,19.5951488 L62.2002448,19.5951488 L56.7940692,11.71102 L53.998374,11.71102 L53.998374,19.5951488 L51.7950167,19.5951488 L51.7950167,1.47107582 Z M57.4038802,9.96248146 C59.9933929,9.96248146 61.3877459,8.84739552 61.3877459,6.61547858 L61.3877459,6.51426577 C61.3877459,4.05549254 59.8658393,3.24404502 57.4038802,3.24404502 L54.0018686,3.24404502 L54.0018686,9.96248146 L57.4038802,9.96248146 Z M65.8171754,13.1053137 L65.8171754,12.9028881 C65.8171754,8.89974697 68.3822258,6.10766949 72.0358499,6.10766949 C75.10762,6.10766949 78.0011646,7.95742082 78.0011646,12.6987174 L78.0011646,13.3845214 L67.999565,13.3845214 C68.1026563,16.3999651 69.5494285,18.0734665 72.2647475,18.0734665 C74.3213308,18.0734665 75.5129959,17.3126254 75.7925654,15.7665125 L77.8998206,15.7665125 C77.4420255,18.4294564 75.2351736,19.8220051 72.2402852,19.8220051 C68.4835697,19.8220051 65.8171754,17.1869819 65.8171754,13.1053137 Z M75.8432373,11.6918244 C75.6405494,8.94860832 74.2199868,7.85271791 72.0358499,7.85271791 C69.8779227,7.85271791 68.4381397,9.32902888 68.0764466,11.6918244 L75.8432373,11.6918244 Z M79.8463234,15.9183317 C79.8463234,12.8522817 83.0945718,11.8122328 86.4965834,11.8122328 L88.3994034,11.8122328 L88.3994034,10.8489661 C88.3994034,8.74618271 87.5869045,7.85271791 85.5617728,7.85271791 C83.734087,7.85271791 82.7189002,8.61355903 82.5162123,10.2364541 L80.4054624,10.2364541 C80.6832847,7.22450048 83.0945718,6.10766949 85.6578748,6.10766949 C88.2211778,6.10766949 90.5066587,7.15469854 90.5066587,10.847221 L90.5066587,19.5934037 L88.3994034,19.5934037 L88.3994034,17.9216473 C87.4104262,19.1641218 86.2170138,19.8220051 84.2635218,19.8220051 C81.7998154,19.8220051 79.8463234,18.631882 79.8463234,15.9183317 Z M88.3994034,14.955065 L88.3994034,13.3077393 L86.5717177,13.3077393 C83.9070707,13.3077393 81.9535787,13.9673676 81.9535787,15.9253119 C81.9535787,17.2951749 82.6123143,18.1572289 84.4662097,18.1572289 C86.6992713,18.1485036 88.3994034,17.008987 88.3994034,14.955065 Z M93.1555799,13.1053137 L93.1555799,12.9028881 C93.1555799,8.84739552 96.0456298,6.10766949 99.6031519,6.10766949 C102.37089,6.10766949 104.958656,7.37457464 105.369273,10.7460082 L103.282986,10.7460082 C102.954492,8.64322485 101.430838,7.85271791 99.6031519,7.85271791 C97.1918648,7.85271791 95.3397167,9.77227118 95.3397167,12.8976529 L95.3397167,13.1053137 C95.3397167,16.3493587 97.1167305,18.0734665 99.6800335,18.0734665 C101.558391,18.0734665 103.258523,16.9845563 103.487421,14.8294215 L105.440913,14.8294215 C105.161343,17.693046 102.853148,19.8220051 99.6538239,19.8220051 C95.9477804,19.8220051 93.1555799,17.2114126 93.1555799,13.1053137 Z M108.102065,0 L110.209321,0 L110.209321,8.44079923 C110.819132,7.2000698 112.295608,6.10766949 114.474503,6.10766949 C117.216032,6.10766949 119.145061,7.60317599 119.145061,11.4562429 L119.145061,19.5934037 L117.037806,19.5934037 L117.037806,11.3061687 C117.037806,8.973039 116.048829,7.93473519 113.917111,7.93473519 C111.961872,7.93473519 110.211068,9.17720967 110.211068,11.5592008 L110.211068,19.5951488 L108.102065,19.5951488 L108.102065,0 Z M128.411044,16.0928366 C128.411044,13.0267865 131.661039,11.9867376 135.061304,11.9867376 L136.965871,11.9867376 L136.965871,11.0234709 C136.965871,8.92068755 136.153372,8.0324579 134.122998,8.0324579 C132.295313,8.0324579 131.280126,8.79329901 131.077438,10.416194 L128.970183,10.416194 C129.24451,7.39900532 131.661039,6.28217433 134.224342,6.28217433 C136.787645,6.28217433 139.071379,7.32920339 139.071379,11.0217259 L139.071379,19.7679086 L136.974607,19.7679086 L136.974607,18.0961522 C135.983883,19.3386266 134.790471,19.9965099 132.836979,19.9965099 C130.366283,19.9965099 128.411044,18.8063869 128.411044,16.0928366 Z M136.97286,15.1295698 L136.97286,13.4822441 L135.138185,13.4822441 C132.473538,13.4822441 130.518299,14.1418724 130.518299,16.0998168 C130.518299,17.4696798 131.178782,18.3317337 133.03093,18.3317337 C135.265739,18.3230085 136.965871,17.1834918 136.965871,15.1295698 L136.97286,15.1295698 Z M142.204305,2.35407033 C142.204305,1.58305942 142.830142,0.958031585 143.602152,0.958031585 C144.374162,0.958031585 145,1.58305942 145,2.35407033 C145,3.12508123 144.374162,3.75010907 143.602152,3.75010907 C142.830142,3.75010907 142.204305,3.12508123 142.204305,2.35407033 Z M142.585218,6.51252072 L144.68199,6.51252072 L144.68199,19.7748888 L142.585218,19.7748888 L142.585218,6.51252072 Z M122.604734,18.6039613 C122.604734,17.8329504 123.230572,17.2079225 124.002582,17.2079225 C124.774592,17.2079225 125.400429,17.8329504 125.400429,18.6039613 C125.400429,19.3749722 124.774592,20 124.002582,20 C123.232949,19.9942991 122.610442,19.3725984 122.604734,18.6039613 Z M19.2915654,8.45999476 C20.6003002,14.4839019 16.0188547,19.855161 10.2125453,19.8272402 C8.97195552,19.8272402 7.96026332,19.8272402 6.68123277,19.8272402 L0.132316765,19.8272402 C0.0893748488,19.8282405 0.0487387658,19.8078783 0.0238719881,19.7729 C-0.000994789558,19.7379217 -0.00684569222,19.692894 0.00825779046,19.6527354 L0.18298874,19.2339237 C0.329762738,18.8953843 0.572638759,18.3299887 0.651267686,18.1554838 C0.667730584,18.1173702 0.705825977,18.093159 0.747369708,18.0944071 L3.88204295,18.0944071 C4.41322504,18.0944071 9.10999297,18.1153477 9.84735758,18.1153477 C13.7473524,18.1118576 16.8383429,15.3442108 17.2419714,11.2154262 C17.6455999,7.08664165 14.8324316,3.43600035 10.9516572,3.05906989 C7.07088278,2.68213943 3.26349539,5.7586598 2.88607653,9.89616962 C2.83458845,10.4307861 2.84573006,10.9695765 2.91927542,11.5016142 C2.92842239,11.545146 2.91703416,11.5904614 2.88838788,11.6245199 C2.8597416,11.6585785 2.8170143,11.6776031 2.77250142,11.676119 L1.17546054,11.676119 C1.09454814,11.6760435 1.02601837,11.6165295 1.01470806,11.5365151 C0.957315464,11.1166532 0.928709482,10.6933661 0.929089896,10.26961 C0.906374873,4.72908123 5.78486299,0.628217433 11.47585,1.3262368 C15.3307148,1.81157995 18.4615377,4.66922406 19.2915654,8.45999476 Z",
    "fill-rule": "nonzero",
    fill: _ctx.fill
  }, null, 8 /* PROPS */, _hoisted_3$2)])], 8 /* PROPS */, _hoisted_1$3);
}

script$3.render = render$3;
script$3.__file = "src/components/ServiceNavigationLogo/DefaultBigLogo.vue";

var script$2 = defineComponent({
  name: 'DefaultSmallLogo',
  props: {
    fill: {
      type: String,
      default: 'white'
    },
    height: {
      type: String,
      default: '16px'
    }
  }
});

const _hoisted_1$2 = {
  height: "23px",
  width: "24px",
  viewBox: "0 0 20 21",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2$1 = {
  id: "wait-for",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
};
const _hoisted_3$1 = ["fill"];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1$2, [createElementVNode("g", _hoisted_2$1, [createElementVNode("path", {
    id: "Combined-Shape",
    d: "M20.7925291,9.65829723 C20.0269981,6.15819961 17.1394534,3.51967723 13.5841279,3.07154978 C8.33535465,2.42705394 3.83594571,6.21346698 3.85689568,11.3291527 C3.85654482,11.7204156 3.882928,12.1112454 3.93586095,12.4989126 C3.9462924,12.5727916 4.00949712,12.6277421 4.08412228,12.6278118 L5.55706632,12.6278118 C5.59812036,12.6291821 5.63752757,12.6116163 5.66394792,12.5801693 C5.69036826,12.5487223 5.70087157,12.5068817 5.69243536,12.4666878 C5.62460479,11.9754464 5.61432893,11.47797 5.66181617,10.9843474 C6.00990798,7.16409834 9.52144526,4.32348294 13.1006671,4.67151069 C16.6798889,5.01953844 19.2744621,8.39025167 18.9021972,12.2024445 C18.5299324,16.0146374 15.6791249,18.5700634 12.0821762,18.5732859 C11.402108,18.5732859 7.07029877,18.553951 6.58039178,18.553951 L3.68929592,18.553951 C3.65098031,18.5527986 3.61584509,18.5751533 3.60066143,18.6103444 C3.5281423,18.7714684 3.30413878,19.29351 3.16876974,19.6060905 L3.00761613,19.992788 C2.99368625,20.0298673 2.99908251,20.0714423 3.02201703,20.1037385 C3.04495156,20.1360347 3.08243004,20.1548355 3.12203519,20.1539119 L9.1620727,20.1539119 C10.3417172,20.1539119 11.2747966,20.1539119 12.4189873,20.1539119 C17.7741219,20.1796918 21.9995697,15.2202963 20.7925291,9.65829723 Z",
    fill: _ctx.fill,
    "fill-rule": "nonzero"
  }, null, 8 /* PROPS */, _hoisted_3$1)])]);
}

script$2.render = render$2;
script$2.__file = "src/components/ServiceNavigationLogo/DefaultSmallLogo.vue";

var script$1 = defineComponent({
  name: 'DefaultLogo',
  components: {
    DefaultBigLogo: script$3,
    DefaultSmallLogo: script$2
  },
  props: {
    target: {
      type: String,
      default: '/'
    },
    service: {
      type: String,
      required: true
    }
  },
  computed: {
    linkAttribute() {
      return this.service === DASHBOARD_SERVICE ? '_self' : '_blank';
    }
  }
});

const _hoisted_1$1 = {
  class: "default-logo",
  "data-test": "default-logo"
};
const _hoisted_2 = ["href", "target"];
const _hoisted_3 = ["href", "target"];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_default_big_logo = resolveComponent("default-big-logo");
  const _component_default_small_logo = resolveComponent("default-small-logo");
  return openBlock(), createElementBlock("div", _hoisted_1$1, [createElementVNode("a", {
    class: "big-logo",
    href: _ctx.target,
    target: _ctx.linkAttribute
  }, [createVNode(_component_default_big_logo)], 8 /* PROPS */, _hoisted_2), createElementVNode("a", {
    class: "small-logo",
    href: _ctx.target,
    target: _ctx.linkAttribute
  }, [createVNode(_component_default_small_logo)], 8 /* PROPS */, _hoisted_3)]);
}

var css_248z$1 = ".default-logo[data-v-4aa2f951] {\n  display: grid;\n  align-items: center;\n  height: 48px;\n  cursor: pointer;\n}\n.default-logo .big-logo[data-v-4aa2f951] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  height: 16px;\n}\n.default-logo .small-logo[data-v-4aa2f951] {\n  display: none;\n}\n@media only screen and (max-width: 768px) {\n.default-logo .big-logo[data-v-4aa2f951] {\n    display: none;\n}\n.default-logo .small-logo[data-v-4aa2f951] {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    height: 24px;\n}\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-4aa2f951";
script$1.__file = "src/components/ServiceNavigationLogo/DefaultLogo.vue";

var script = defineComponent({
  components: {
    BrandLogo: script$4,
    DefaultLogo: script$1
  },
  props: {
    logoUrl: {
      type: String,
      default: undefined
    },
    defaultLogoTarget: {
      type: String,
      default: undefined
    },
    service: {
      type: String,
      required: true
    }
  }
});

const _hoisted_1 = {
  class: "logo",
  "data-test": "logo"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_brand_logo = resolveComponent("brand-logo");
  const _component_default_logo = resolveComponent("default-logo");
  return openBlock(), createElementBlock("div", _hoisted_1, [_ctx.logoUrl ? (openBlock(), createBlock(_component_brand_logo, {
    key: 0,
    logo: _ctx.logoUrl
  }, null, 8 /* PROPS */, ["logo"])) : renderSlot(_ctx.$slots, "default", {
    key: 1
  }, () => [createVNode(_component_default_logo, {
    service: _ctx.service,
    target: _ctx.defaultLogoTarget
  }, null, 8 /* PROPS */, ["service", "target"])])]);
}

var css_248z = ".logo[data-v-4f4bf579] {\n  max-width: 35%;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-4f4bf579";
script.__file = "src/components/ServiceNavigationLogo/ServiceNavigationLogo.vue";

export { script as s };
